import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-expandable-elevation-section',
  templateUrl: './expandable-elevation-section.component.html',
  styleUrls: ['./expandable-elevation-section.component.css']
})
export class ExpandableElevationSectionComponent implements OnChanges {
  @Input() contentMaxHeight = "auto";
  @Input() isExpandedInput = true; 
  @Input() hideButton = false; 
  @Output() emitIsExpanded = new EventEmitter<boolean>(true); 
  isExpanded = true; 

  constructor() {
    this.isExpanded = this.isExpandedInput; 
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.isExpandedInput.currentValue != changes.isExpandedInput.previousValue) this.isExpanded = changes.isExpandedInput.currentValue; 
  }

  onExpandClick() {
    this.isExpanded = !this.isExpanded; 
    this.emitIsExpanded.emit(this.isExpanded); 
    console.log("Expanded: ", this.isExpanded); 
  }


}
